import { render, staticRenderFns } from "./globalSideNav.vue?vue&type=template&id=a79647b0&scoped=true&"
import script from "./globalSideNav.vue?vue&type=script&lang=js&"
export * from "./globalSideNav.vue?vue&type=script&lang=js&"
import style0 from "./globalSideNav.vue?vue&type=style&index=0&id=a79647b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79647b0",
  null
  
)

export default component.exports